<template>
    <RegisterStep
        :ready="ready"
        :loading="loading"
        :order-step="orderStep"
        :show-submit="showSubmit"
        @submit="handleStepSubmitted"
        v-bind="$attrs"
    >

        <template v-slot:title>
            <template v-if="course.registration_level === 'APPLICATION'">
                vous réalisez une candidature
            </template>
            <template v-else>
                vous réalisez une inscription
            </template>
        </template>

        <div ref="content" style="max-width: 600px">
            <template v-if="!currentOrder.id && editingAccountType">
                <AccountTypeSelector
                    v-model="currentOrder"
                    :editing="true"
                    @input="handleAccountTypeChanged"
                />
            </template>
            <template v-else>
                <AccountTypeSelector
                    class="mb-4"
                    v-model="currentOrder"
                    :editing.sync="editingAccountType"
                    @input="handleAccountTypeChanged"
                />

                <template v-if="isThirdPartyAllowed">
                    <ThirdPartySelector
                        v-model="currentOrder"
                        :errors="errors"
                    />
                </template>
            </template>
        </div>
    </RegisterStep>
</template>
<script>
    import { clone } from "../../../util";
    import RegisterStep from "../RegisterStep.vue";
    import { nextStep, registerSteps } from "../../../util/register";
    import { postOrderAccountType } from "../../../api";
    import ThirdPartySelector from "./account-type/ThirdPartySelector.vue";
    import AccountTypeSelector from "./account-type/AccountTypeSelector.vue";

    export default {
        components: {
            AccountTypeSelector,
            ThirdPartySelector,
            RegisterStep,
        },
        props: {
            order: Object,
            course: Object,
            session: Object,
            orderStep: String,
            user: Object,
        },
        data() {
            return {
                ready: false,
                loading: false,
                errors: null,
                currentOrder: {
                    account_type: null,
                    third_party: null,
                    third_party_with_self: null,
                    is_quote: false,
                    ...clone(this.order),
                },
                editingAccountType: false,
            }
        },
        computed: {
            isThirdPartyAllowed() {
                return this.currentOrder.account_type === 'organization'
                    && this.course.registration_level === 'INSCRIPTION';
            },
            showSubmit() {
                if(!this.currentOrder.id && this.editingAccountType) {
                    return !!this.currentOrder.account_type;
                }
                return true;
            },
        },
        methods: {
            init() {
                if(!this.order?.id) {
                    const query = this.$route.query;
                    this.currentOrder = {
                        ...this.currentOrder,
                        is_quote: !!Number(query.devis)
                    };
                    this.$emit('update:order', {
                        ...this.currentOrder,
                    });
                }
                this.editingAccountType = !this.order?.id || !this.isThirdPartyAllowed;
                this.ready = true;
            },
            async handleStepSubmitted() {
                if(!this.currentOrder.id && this.isThirdPartyAllowed && this.editingAccountType) {
                    this.editingAccountType = false;
                    return;
                }
                const { orderId } = this.$route.params;

                this.nextStep = this.getNextStep();
                this.nextRoute = this.nextStep.route;

                const order = await this.post({
                    nextStep: this.nextStep,
                });

                this.currentOrder = order;
                this.$emit('update:order', order);

                if(!orderId) {
                    await this.$router.replace({
                        name: 'register-account-type',
                        params: {
                            orderId: order.id,
                        },
                    });
                }
                await this.$router.push({
                    ...this.nextRoute,
                    params: {
                        orderId: order.id,
                    },
                });
            },
            handleAccountTypeChanged() {
                this.currentOrder = {
                    ...this.currentOrder,
                    third_party: null,
                    third_party_with_self: null,
                }
            },
            async post({ nextStep }) {
                const { courseId, sessionId, orderId } = this.$route.params;

                this.loading = true;
                this.errors = null;

                return postOrderAccountType({
                    courseId,
                    sessionId,
                    orderId,
                    data: {
                        ...this.currentOrder,
                        next_step: nextStep?.value,
                    },
                })
                .catch(error => {
                    if(error.response?.status === 403) {
                        this.$emit('error', error.response.data.message);
                    }
                    else if(error.response?.status === 422) {
                        this.errors = error.response.data.errors;
                    }
                    return Promise.reject(error);
                })
                .finally(() => {
                    this.loading = false;
                })
            },
            getNextStep() {
                const steps = registerSteps({
                    order: this.currentOrder,
                    course: this.course,
                    session: this.session,
                });
                const { account_type, third_party, third_party_with_self } = this.currentOrder;

                // account changed: ignore current order step
                if(this.order?.account_type !== account_type
                    || this.order?.third_party !== third_party
                    || this.order?.third_party_with_self !== third_party_with_self
                ) {
                    return nextStep(steps, this.$route);
                }

                return nextStep(steps, this.$route, this.orderStep);
            },
        },
        created() {
            this.init();
        },
    }
</script>
